"use client";

/*eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import { productos } from "../../libs/productosV3";
import VideoComponent from "../../libs/VideoComponent";

interface SidebarProps {
  setSelectedCategory: (category: string) => void;
  setSearchTerm: (term: string) => void; // Recibir la función de búsqueda
  categoriasData: any;
  selectedCategory: any;
}

const Sidebar: React.FC<SidebarProps> = ({
  setSelectedCategory,
  setSearchTerm,
  categoriasData,
  selectedCategory,
}) => {
  return (
    <>
      <aside className="widget-area">
        <div className="widget widget_search">
          <h3 className="widget-title">
            <span>Buscar</span>
          </h3>
          <form
            className="search-form"
            onSubmit={(e) => e.preventDefault()} // Prevenir el submit del formulario
          >
            <input
              type="search"
              className="search-field"
              placeholder="Escribe un producto..."
              onChange={(e) => setSearchTerm(e.target.value)} // Actualizar el término de búsqueda
            />
            <button type="submit">
              <i className="bx bx-search"></i>
            </button>
          </form>
        </div>

        <div className="widget widget_categories">
          <h3 className="widget-title">
            <span>Categorías</span>
          </h3>
          <ul>
            <li
              className={
                selectedCategory === "Todas las categorías" ? "active" : ""
              }
            >
              <Link
                to=""
                onClick={() => setSelectedCategory("Todas las categorías")}
              >
                Todas las categorías
                <span className="count">({productos.length})</span>
              </Link>
            </li>
            {categoriasData?.map((item: any) =>
              item?.productos?.length > 0 ? (
                <li
                  key={item.category}
                  className={item.title === selectedCategory ? "active" : ""}
                >
                  <Link to="" onClick={() => setSelectedCategory(item.title)}>
                    {item.title}{" "}
                    <span className="count">({item.productos.length})</span>
                  </Link>
                </li>
              ) : null
            )}
          </ul>
        </div>
        <div>
          <VideoComponent url="https://www.youtube.com/embed/vshMlLflW6w" />
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
